import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../../actions';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';


class ClearPDFButton extends Component {
    constructor(props, context) {
        super(props, context);
        
    }

    render () {
        const p = this.props;
        const aid = p.aid;
        const cpst = p.overview.clearPdfState[aid] || {};

        let content = <RaisedButton
            primary
            onClick={(function (e) { p.clearPdf(aid); }).bind(this) }
            label="Clear PDF" />

        if (cpst.loading) {
            content = <CircularProgress />
        }

        if (cpst.failed) {
            content = <span>Failed, sorry.</span>
        }

        if (cpst.done) {
            content = <span>Cleared!</span>
        }


        return (
            <div>
                { content }
            </div>
            
        )
        
    }
}

const mapStateToProps = function (appState) {
    return {
        overview: appState.overview
    };
}

const mapDispatchToProps = function (dispatch) {
    return {
        clearPdf : function (aid) {
            dispatch( actions.clearPdf(aid))
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ClearPDFButton);